import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { tr } from "@/lib/translations";
import { HERO_BG, ISLAND_IMAGES } from "@/lib/images";
import { SiteImg } from "@/components/SiteImg";
import { TOPIC_ICONS, topicLabel } from "@/lib/tipTopics";

/** Kachel eines Reisetipps (Startseite + Übersicht /reisetipps): Bild, Titel, Auszug, Insel, Thema. */
export const TipCard = ({ tip: p, showIsland = true, testId }) => {
  const { t, lang } = useLang();
  const title = tr(p.title, lang);
  const excerpt = tr(p.excerpt, lang);
  const img = p.image || p.hero_image || (p.island && ISLAND_IMAGES[p.island]) || HERO_BG;
  const TopicIcon = TOPIC_ICONS[p.topic];
  return (
    <Link to={p.path} className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-stone-200 hover:border-brand/50 transition-colors" data-testid={testId || `tip-card-${p.island || "general"}-${p.slug}`}>
      <div className="relative aspect-[16/10] overflow-hidden img-hover-zoom bg-tint">
        <SiteImg src={img} alt={tr(p.hero_alt, lang) || title} className="w-full h-full object-cover" loading="lazy" decoding="async" />
        {TopicIcon && <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-white/90 text-stone-800 text-[11px] uppercase tracking-wider font-semibold px-3 py-1" data-testid={`tip-card-topic-${p.slug}`}><TopicIcon className="w-3.5 h-3.5 text-brand" />{topicLabel(t, p.topic)}</span>}
      </div>
      <div className="p-5 flex flex-col flex-1">
        {showIsland && p.island && <span className="inline-flex items-center gap-1 text-[11px] uppercase tracking-wider text-brand font-semibold mb-2"><MapPin className="w-3 h-3" />{t.islands[p.island] || p.island}</span>}
        <h3 className="font-serif text-xl leading-snug text-stone-900 group-hover:text-brand transition-colors">{title}</h3>
        {excerpt && <p className="mt-2 text-sm text-stone-600 leading-relaxed line-clamp-3">{excerpt}</p>}
        <span className="mt-auto pt-3 inline-block text-sm text-brand underline underline-offset-4">{t.tips.read} →</span>
      </div>
    </Link>
  );
};
